import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { toKeyValObject } from '@/utils/state_helpers'
import store from '@/store'

export const useSubsitesStore = defineStore('subsites', {
  state: () => ({
    subsites: [],
    fetchInitiated: false
  }),

  getters: {
    asObject: ({ subsites }) => {
      return toKeyValObject(subsites, 'name', 'id')
    },

    hasMultiple() {
      return this.subsites.length > 1
    },

    forPublication: ({ subsites }) => ({ publicationId }) => {
      const pubSubsites = subsites.filter((sub) => sub.publication_id === publicationId)

      return pubSubsites ? pubSubsites : []
    },

    forPublicationAsObject() {
      return ({ publicationId }) => {
        const pubSubsites = this.forPublication({ publicationId })

        return toKeyValObject(pubSubsites, 'name', 'id')
      }
    }
  },

  actions: {
    async fetch() {
      this.fetchInitiated = true

      return await httpClient.get('/api/internal/subsites')
        .then(({ data: { subsites } }) => {
          this.subsites = subsites
        })
        .catch((err) => {
          store.dispatch('messages/smartAdd', err)
        })
    },

    async fetchOnce() {
      if (this.fetchInitiated) return Promise.resolve()

      return await this.fetch()
    },

    async sync({ publicationId }) {
      return httpClient.post(`/api/internal/publications/${publicationId}/subsites`)
        .then(({ data: { subsites } }) => {
          this.subsites = subsites
          store.dispatch('messages/addNotice', 'Subsites synced')
        })
        .catch((err) => {
          store.dispatch('messages/smartAdd', err)
        })
    }
  }
})
